// 菜单
export default {
    groundStationSetting: 'Настройки наземной станции',
    parameterSet: 'настройки параметров',
    deviceManagement: 'Управление оборудованием',
    sharingManagement: 'Совместное управление',
    historyPlayback: 'Воспроизведение истории',
    flightRecords: 'Рекорд полета',
    historicalRecords: 'запись истории',
    videoRecords: 'запись видео',
    photoRecords: 'фотозапись',
    lpr: 'Идентификационная запись',
    inspectionRecord: 'Проверка записей',
    mobileSpectrumRecord: 'Записи спектра сотового телефона',
    lifeDetectionRecord: 'Запись обнаружения жизни',
    flightRecordDetails: 'Подробности отчета о проверке',
    enterpriseUsers: 'Информация о корпоративном пользователе',
    lifeStatistics: 'Статистика жизни',
    flightRecordPlayback: 'Воспроизведение полетной записи',
    details_uav: 'Сведения об устройстве (дрон)',
    details_PTZ: 'Подробная информация об устройстве (камеры)',
    details_battery: 'Сведения об устройстве (умная батарея)',
    details_rtk: 'Сведения об устройстве(RTK)',
    details_simulator: 'Сведения об устройстве(Симулятор)',
    weatherStation: 'Cведения о устройстве (метеостанция)',
    oplog: 'Журнал работы',
    systemOperation: 'операция системы',
    flightOperation: 'Полетные операции',
    productAftersale: 'Продукция после продажи',
    modelDataManagement: 'Платформа объединения 3D-данных',
    positioning3Ddata: 'Позиционирование 3D-данных',
}